module.exports = "/images/ai.png?573d47f8fdabd8036e083429129c7151";